var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.09995 0.675049C8.35686 0.675049 8.59151 0.820898 8.70522 1.05128L10.6341 4.95891L14.9476 5.5894C15.2017 5.62655 15.4128 5.80475 15.492 6.04911C15.5713 6.29346 15.5049 6.56161 15.3209 6.74084L12.2002 9.78037L12.9367 14.0744C12.9802 14.3277 12.8761 14.5836 12.6682 14.7347C12.4603 14.8857 12.1847 14.9056 11.9573 14.786L8.09995 12.7574L4.24263 14.786C4.01521 14.9056 3.73961 14.8857 3.53173 14.7347C3.32384 14.5836 3.21973 14.3277 3.26316 14.0744L3.99964 9.78037L0.878977 6.74084C0.69496 6.56161 0.628625 6.29346 0.707855 6.04911C0.787085 5.80475 0.998144 5.62655 1.25232 5.5894L5.56582 4.95891L7.49467 1.05128C7.60839 0.820898 7.84303 0.675049 8.09995 0.675049ZM8.09995 2.87505L6.61947 5.87432C6.52123 6.07334 6.33143 6.21135 6.11182 6.24345L2.80012 6.72751L5.19592 9.06101C5.35513 9.21608 5.4278 9.4396 5.39023 9.65865L4.82497 12.9544L7.78577 11.3974C7.98245 11.2939 8.21744 11.2939 8.41413 11.3974L11.3749 12.9544L10.8097 9.65865C10.7721 9.4396 10.8448 9.21608 11.004 9.06101L13.3998 6.72751L10.0881 6.24345C9.86846 6.21135 9.67866 6.07334 9.58042 5.87432L8.09995 2.87505Z",
    fill: "#FAC915"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.bdff23659f54d73a6913e0522d75639e.svg";
export { ForwardRef as ReactComponent };